/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{s}from"../../../../../chunks/vec3.js";import{c as n}from"../../../../../chunks/vec4f64.js";import{c as o,g as c,h as r}from"../../../../../chunks/boundedPlane.js";function t(n,o){return c(o.extent,e),r(e,s(a,n.x,n.y,0))}const e=o(),a=n();export{t as distanceToTile};
